// @flow
import * as ActionTypes from "../../actionTypes";
import { createAction } from "redux-actions";

type Action = {
  +type: string,
  +payload?: any,
  +error?: boolean,
  +meta?: any
};

export const toggleD1: Action = createAction(ActionTypes.TOGGLE_D1);

export const incrementD2: Action = createAction(
  ActionTypes.INCREMENT_D2,
  amount => ({
    amount: 1
  }),
  amount => ({ amount: 1, apiRoute: "/bitcoin/increment" })
);
export const decrementD2: Action = createAction(
  ActionTypes.DECREMENT_D2,
  amount => ({
    amount: -1
  }),
  amount => ({ amount: -1, apiRoute: "/bitcoin/decrement" })
);



// WEBPACK FOOTER //
// ./src/features/play/playActions.js